import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Divider, Grid, List, ListItem } from '@material-ui/core';

import  '../../../styles/styles.css'
import { estados } from '../../../helpers/estados';
const styles = (theme) => ({
  
  typography:{
    fontFamily: 'Montserrat, sanserif', 
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);



export const DialogInfo = (props) => {
  /*const stylesHeader = (props.afiliadoSelec.estado === estados.Preafiliacion_BandejaSeccional || (props.afiliadoSelec.estado === estados.Preafiliacion_BandejaNacional )) 
  ? {color: blue[500], cursor: "pointer"} : ((props.afiliadoSelec.estado === estados.Preafiliacion_BandejaSeccionalModificada || props.afiliadoSelec.estado === estados.Preafiliacion_PresencialIngresada) 
  ? {color: orange[500], cursor: "pointer"} : (((props.afiliadoSelec.estado === estados.Preafiliacion_BandejaNacionalObservada) || props.afiliadoSelec.estado === estados.Preafiliacion_BandejaNacionalModificada) 
  ? {color: lime[500], cursor: "pointer"} : (((props.afiliadoSelec.estado === estados.Preafiliacion_BandejaNacional) || props.afiliadoSelec.estado === estados.Preafiliacion_BandejaNacionalAprobada) 
  ? {color: green[500], cursor: "pointer"} : {color: red[500], cursor: "pointer"}
  )));*/
  return (
    <div>
      <Dialog  maxWidth="sm" fullWidth={true} onClose={props.handleClose} aria-labelledby="customized-dialog-title" open={props.open}>
        <DialogTitle id="customized-dialog-title" >
          <Grid container item justify="center" ><Typography variant="h5" component="h3">Datos cargados del Preafiliado</Typography></Grid>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container justify="center"><Typography variant="h6" component="p" class="typografy"><strong>Nombre Completo: </strong>{props.afiliadoSelec?.apellido_y_nombre}</Typography></Grid>
          <Grid container justify="center" direction="row"><Grid item><Typography variant="h6" component="p"class="typografy"><strong> Dirección:</strong> {`${props.afiliadoSelec?.domiciliosAfiliados?.calle} ${props.afiliadoSelec.domiciliosAfiliados?.nro}`}</Typography></Grid><Grid item><Typography variant="h6" component="p"class="typografy"><strong>Teléfono:</strong> {`${props.afiliadoSelec?.domiciliosAfiliados?.telefono}`}</Typography></Grid></Grid>
          
          <Grid container justify="center">
            <Grid item><Typography variant="h6" component="p"class="typografy"><strong>Estado: </strong> 
              {(props.afiliadoSelec.estado === estados.Preafiliacion_BandejaSeccionalObservada && 'Bandeja Seccional Observada') || 
              (props.afiliadoSelec.estado === estados.Preafiliacion_BandejaNacionalAprobada && 'Aceptada')}</Typography></Grid>
            <Grid item><Typography variant="h6" component="p"class="typografy"><strong>Cuil: </strong> {props.afiliadoSelec.cuil}</Typography></Grid>
          </Grid>
          <Divider />
          <Grid item container justify="center" alignItems="center">
              <Grid item><Typography variant="h6" component="p" class="typografy"><strong>Empresas: </strong></Typography></Grid>
              <Grid item>
              <List component="nav" aria-label="secondary mailbox folders">
              {
                props.empresas.map(item => 
                <ListItem button>
                  <Typography variant="h6" component="p" class="typografy"  >{item.empresa.denominacion}</Typography>
                </ListItem>
                )
              }
              </List>
              </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}